import { FC } from 'react';

import { Progress } from '@eluve/components';

export interface ProgressRendererProps {
  value: number;
  variant?: 'default' | 'success';
}

export const ProgressRenderer: FC<ProgressRendererProps> = ({
  value,
  variant = 'default',
}) => (
  <Progress
    value={value}
    className={
      variant === 'success'
        ? 'absolute inset-x-0 bottom-0 h-1 rounded-none bg-transparent [&>div]:bg-text-positive'
        : undefined
    }
  />
);
